import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      '50': '#CDE1D8',
      '100': '#A5D5C1',
      '200': '#79C8A7',
      '300': '#4EBA8F',
      '400': '#31B07E',
      '500': '#1DA772',
      '600': '#189764',
      '700': '#128153',
      '800': '#0C6C43',
      '900': '#024827',
      A100: '#88E6B6',
      A200: '#42E491',
      A400: '#2BD08E',
      A700: '#2BD08E',
    },
    secondary: {
      main: '#5fa9ff',
      light: '#97daff',
      dark: '#107abc',
    },
    error: {
      main: '#fe7877',
    },
    action: {
      selected: '#E8F1EC',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

export default theme;
